/**
 * Connection Status Field Component
 * Dropdown for system connection status filter
 */

import React from 'react'
import { FormControl, Select, MenuItem, Typography, Box, SelectChangeEvent } from '@mui/material'
import { CONNECTION_STATUS_OPTIONS } from '../types'

interface ConnectionStatusFieldProps {
  value: string
  onChange: (value: string) => void
  label?: string
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const ConnectionStatusField: React.FC<ConnectionStatusFieldProps> = ({
  value,
  onChange,
  label = 'Connection Status',
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value)
  }

  return (
    <Box>
      <Typography component="label" sx={labelStyle}>
        {label}
      </Typography>
      <FormControl fullWidth size="small">
        <Select displayEmpty value={value} onChange={handleChange}>
          {CONNECTION_STATUS_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default ConnectionStatusField
